@export fn getInstancedFaceIndex(v: u32, i: u32) -> vec2<u32> { return vec2<u32>(i, i * 3u + v); };
